$(document).ready(function(){

    // testimonial slider
    $(".testimonial-review-list").slick({
        dots: true,
        adaptiveHeight: true,
        arrows: true,
        infinite: true,
        nextArrow: '<div class="next_arrow_slick linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10.7961 10.7961L1 20.5923" stroke="url(#paint0_linear_114_395)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_114_395" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        prevArrow: '<div class="prev_arrow_slick linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7961 1L1 10.7961L10.7961 20.5923" stroke="url(#paint0_linear_114_398)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_114_398" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });

    // FAQs
    $('.faqs-list').on('click', '.acc__title', function (e) {
        var accCard = $(this).closest('.acc__card');
        var accContainer = $(this).closest('.faqs-list');
        var accPanel = accCard.find('.acc__panel');
        var accTitle = $(this);
        var plusIcon = accTitle.find('.plus_icon');
        var minusIcon = accTitle.find('.minus_icon');

        if (accCard.hasClass('active_item')) {
            accCard.removeClass('active_item');
            accTitle.removeClass('active');
            accPanel.stop(true, true).slideUp();
            plusIcon.show();
        } else {
            accContainer.find('.acc__card').not(accCard).each(function () {
                $(this).removeClass('active_item')
                .find('.acc__panel').stop(true, true).slideUp().end()
                .find('.acc__title').removeClass('active')
                .find('.plus_icon').show().end();
            });

            accCard.addClass('active_item');
            accTitle.addClass('active');
            accPanel.stop(true, true).slideDown();
        }
    });

    // PDP Accordions
    $('.product-details-sec').on('click', '.acc__title', function (e) {
        var accCard = $(this).closest('.acc__card');
        var accContainer = $(this).closest('.product-details-sec');
        var accPanel = accCard.find('.acc__panel');
        var accTitle = $(this);
        var plusIcon = accTitle.find('.plus_icon');
        var minusIcon = accTitle.find('.minus_icon');

        if (accCard.hasClass('active_item')) {
            accCard.removeClass('active_item');
            accTitle.removeClass('active');
            accPanel.stop(true, true).slideUp();
            plusIcon.show();
        } else {
            accContainer.find('.acc__card').not(accCard).each(function () {
                $(this).removeClass('active_item')
                .find('.acc__panel').stop(true, true).slideUp().end()
                .find('.acc__title').removeClass('active')
                .find('.plus_icon').show().end();
            });

            accCard.addClass('active_item');
            accTitle.addClass('active');
            accPanel.stop(true, true).slideDown();
        }
    });

    // product page gallery slider
    $(".main-gallery-slick-enabled").slick({    
        dots: false,
        arrows: true,
        prevArrow: '<div class="arrow_prev linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7961 1L1 10.7961L10.7961 20.5923" stroke="url(#paint0_linear_116_1419)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_116_1419" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        nextArrow: '<div class="arrow_next linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10.7961 10.7961L1 20.5923" stroke="url(#paint0_linear_116_1422)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_116_1422" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        asNavFor: '.main-thumbs-slick-enabled',
        slidesToScroll: 1,
        adaptiveHeight: true
    });

    $(".main-thumbs-slick-enabled").slick({
        dots: false,
        asNavFor: '.main-gallery-slick-enabled',
        arrows: false,
        infinite: false,
        slidesToShow: 4,
        verticalSwiping: true,
        vertical: true,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    verticalSwiping: false,
                    vertical: false
                }
            },
            {
                breakpoint: 767,
                settings: {
                    verticalSwiping: false,
                    vertical: false
                }
            }
        ]
    });

    setTimeout(function () {
        $('.main-thumbs-slick-enabled').slick('setPosition');
    }, 200);

    $(".main-gallery-slick-enabled").on('afterChange', function(event, slick, currentSlide){
        var indexslide = currentSlide+1;
        console.log("Current Slide Index:", indexslide);
        $("ul.thumbnail-list li button[aria-current]").removeAttr("aria-current");
        $('ul.thumbnail-list li[data-media-position="' + indexslide + '"] button').attr("aria-current", "true");
    });

    $("ul.thumbnail-list").on("click", "li button", function () {
        var index = $(this).closest("li").data("media-position");
        if (typeof index !== 'undefined') {
            var slideIndex = parseInt(index, 10) - 1;
            $(".main-gallery-slick-enabled").slick("slickGoTo", slideIndex);
        }
    });

    // Play button click
    $('.tiktok-video-embed .video-play svg').on('click', function () {
        var $videoItem = $(this).closest(".tiktok-video-item");
        var $video = $videoItem.find('video');
        var videoEl = $video[0];
        var $poster = $videoItem.find('.video-poster');
        var posterUrl = $video.attr("poster");
        $poster.attr("src", posterUrl);
  
        $video.show();
        $poster.hide();
  
        if (videoEl.paused) {
        videoEl.play();
        $videoItem.addClass('pause-video-act').removeClass('play-video-act ended_video');
        }
    });
  
    // Pause button click
    $('.tiktok-video-embed .video-pause svg').on('click', function () {
        var $videoItem = $(this).closest(".tiktok-video-item");
        var $video = $videoItem.find('video');
        var videoEl = $video[0];
        var $poster = $videoItem.find('.video-poster');
        var posterUrl = $video.attr("poster");
        $poster.attr("src", posterUrl);
  
        if (!videoEl.paused) {
        videoEl.pause();
        videoEl.currentTime = 0;
        $video.hide();
        $poster.show();
        $videoItem.addClass('play-video-act').removeClass('pause-video-act ended_video');
        }
    });
  
    // On video end
    $('.tiktok-video-embed video').on('ended', function () {
        var $video = $(this);
        var videoEl = this;
        var $videoItem = $video.closest(".tiktok-video-item");
        var posterUrl = $video.attr("poster");
        var $poster = $videoItem.find('.video-poster');
    
        videoEl.pause();
        videoEl.currentTime = 0;
        $video.hide();
        $poster.attr("src", posterUrl).show();
        $videoItem.removeClass('play-video-act pause-video-act').addClass("ended_video");
    });

    // home page Review video slider
    $('.tiktok-video-slider').slick({
        dots: false,
        arrows: true,
        prevArrow: '<div class="arrow_prev linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7961 1L1 10.7961L10.7961 20.5923" stroke="url(#paint0_linear_116_1419)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_116_1419" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        nextArrow: '<div class="arrow_next linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10.7961 10.7961L1 20.5923" stroke="url(#paint0_linear_116_1422)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_116_1422" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        infinite: true,
        speed: 300,
        draggable: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });

    if($(window).width() < 749) {
        $('.solutions-list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true
        });
    } else {
        $('.solutions-list').unslick();
    }

    if($(window).width() < 749) {
        $('.articles-list-sec .articles-list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true
        });
    } else {
        $('.articles-list-sec .articles-list').unslick();
    }

});